<!-- MFITTの空席照会で、引換券非対応の区間を選択した場合 -->
<template>
  <ItemDialog ref="invalidSection" image-type="alert">
    <template #content-area>
      <p class="text-center">
        指定可能な区間を超えています。発着駅をご確認ください。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="OK"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogInvalidSectionWithCoupon",
  setup() {
    const invalidSection = ref(null);

    const openDialog = () => {
      invalidSection.value.open();
    };

    const closeDialog = () => {
      invalidSection.value.close();
    };

    return {
      invalidSection,
      openDialog,
      closeDialog,
    };
  },
};
</script>
